import styled from '@emotion/styled';

const StyledDesktop = styled.div({
  'display': 'inline-flex',
  'width': '100%',
  'flexDirection': 'column',
  '& button': {
    margin: '10.5px 0'
  }
});

export default StyledDesktop;
